"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBulkInsertStreamBase = void 0;
const intersection_1 = __importDefault(require("lodash/intersection"));
const tableTransforms_1 = require("./tableTransforms");
function createBulkInsertStreamBase(driver, stream, pool, name, options) {
    const fullNameQuoted = name.schemaName
        ? `${driver.dialect.quoteIdentifier(name.schemaName)}.${driver.dialect.quoteIdentifier(name.pureName)}`
        : driver.dialect.quoteIdentifier(name.pureName);
    const writable = new stream.Writable({
        objectMode: true,
    });
    writable.buffer = [];
    writable.structure = null;
    writable.columnNames = null;
    writable.requireFixedStructure = driver.databaseEngineTypes.includes('sql');
    writable.addRow = (row) => __awaiter(this, void 0, void 0, function* () {
        if (writable.structure) {
            writable.buffer.push(row);
        }
        else {
            writable.structure = row;
            yield writable.checkStructure();
        }
    });
    writable.checkStructure = () => __awaiter(this, void 0, void 0, function* () {
        let structure = yield driver.analyseSingleTable(pool, name);
        // console.log('ANALYSING', name, structure);
        if (structure && options.dropIfExists) {
            console.log(`Dropping table ${fullNameQuoted}`);
            yield driver.script(pool, `DROP TABLE ${fullNameQuoted}`);
        }
        if (options.createIfNotExists && (!structure || options.dropIfExists)) {
            console.log(`Creating table ${fullNameQuoted}`);
            const dmp = driver.createDumper();
            dmp.createTable((0, tableTransforms_1.prepareTableForImport)(Object.assign(Object.assign({}, writable.structure), name)));
            console.log(dmp.s);
            yield driver.script(pool, dmp.s);
            structure = yield driver.analyseSingleTable(pool, name);
        }
        if (options.truncate) {
            yield driver.script(pool, `TRUNCATE TABLE ${fullNameQuoted}`);
        }
        writable.columnNames = (0, intersection_1.default)(structure.columns.map(x => x.columnName), writable.structure.columns.map(x => x.columnName));
    });
    writable.send = () => __awaiter(this, void 0, void 0, function* () {
        const rows = writable.buffer;
        writable.buffer = [];
        const dmp = driver.createDumper();
        dmp.putRaw(`INSERT INTO ${fullNameQuoted} (`);
        dmp.putCollection(',', writable.columnNames, col => dmp.putRaw(driver.dialect.quoteIdentifier(col)));
        dmp.putRaw(')\n VALUES\n');
        let wasRow = false;
        for (const row of rows) {
            if (wasRow)
                dmp.putRaw(',\n');
            dmp.putRaw('(');
            dmp.putCollection(',', writable.columnNames, col => dmp.putValue(row[col]));
            dmp.putRaw(')');
            wasRow = true;
        }
        dmp.putRaw(';');
        // require('fs').writeFileSync('/home/jena/test.sql', dmp.s);
        // console.log(dmp.s);
        yield driver.query(pool, dmp.s);
    });
    writable.sendIfFull = () => __awaiter(this, void 0, void 0, function* () {
        if (writable.buffer.length > 100) {
            yield writable.send();
        }
    });
    writable._write = (chunk, encoding, callback) => __awaiter(this, void 0, void 0, function* () {
        yield writable.addRow(chunk);
        yield writable.sendIfFull();
        callback();
    });
    writable._final = (callback) => __awaiter(this, void 0, void 0, function* () {
        yield writable.send();
        callback();
    });
    return writable;
}
exports.createBulkInsertStreamBase = createBulkInsertStreamBase;
